import moment from 'moment';
import request from '@/utils/request';
import apiConstants from '@/utils/apiConstants';
import constants from '@/utils/constants';

const formatDates = (blockedCutoffData) => {
  const blockedCutoffDataUpdated = Object.assign({}, blockedCutoffData);
  blockedCutoffDataUpdated.receivingDate = moment(blockedCutoffDataUpdated.receivingDate.getTime())
    .format(constants.DATES.DEFAULT_BACKEND_FORMAT);
  return blockedCutoffDataUpdated;
};

const warehouseBlockedCutoffGroupService = {
  getWarehouseBlockedCutoffGroup(filters) {
    const filtersUpdated = formatDates(filters);
    return request({
      url: apiConstants.END_POINTS.WAREHOUSE_BLOCKED_CUTOFF_GROUP.DEFAUTL,
      method: 'get',
      params: filtersUpdated
    });
  },
};

export default warehouseBlockedCutoffGroupService;
